import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "./allAssessments.module.css";

/* ================= API ================= */

const fetchCompanyData = async () => {
  const res = await fetch("https://casaahaanahotels.com/search_company_data", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ useremail: "" }),
  });
  return await res.json();
};

/* ================= COMPONENT ================= */

const CompanyAssessmentDashboard = () => {
  const userData = JSON.parse(localStorage.getItem("user_data") || "{}");
  const adminType = userData?.admin_type; // 1 = super admin, 2 = company admin

  const [companies, setCompanies] = useState([]);
  const [allAssessments, setAllAssessments] = useState([]);
  const [assessments, setAssessments] = useState([]);

  const [selectedCompanyCode, setSelectedCompanyCode] = useState(
    userData?.admincode || ""
  );

  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;

  /* ================= INITIAL LOAD ================= */

  useEffect(() => {
    initLoad();
  }, []);

  const initLoad = async () => {
    setLoading(true);
    try {
      const [assessmentRes, companyRes] = await Promise.all([
        axios.post(
          "https://casaahaanahotels.com/api/v2/assessment_scores_enriched",
          {}
        ),
        fetchCompanyData(),
      ]);

      const data = assessmentRes.data?.data || [];
      setAllAssessments(data);
      setCompanies(companyRes);

      // 🔥 first load → company based data
      const filtered = data.filter(
        (a) => a.companycode === userData.admincode
      );
      setAssessments(filtered);
    } finally {
      setLoading(false);
    }
  };

  /* ================= AUTO FILTER ON COMPANY CHANGE ================= */

  useEffect(() => {
    if (!selectedCompanyCode) return;

    setLoading(true);

    const filtered = allAssessments.filter(
      (a) => a.companycode === selectedCompanyCode
    );

    setAssessments(filtered);
    setCurrentPage(1);

    setLoading(false);
  }, [selectedCompanyCode, allAssessments]);

  /* ================= PAGINATION ================= */

  const totalPages = Math.ceil(assessments.length / itemsPerPage);
  const paginated = assessments.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  /* ================= UI ================= */

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Assessment Dashboard</h2>

      {/* ========= SINGLE COMPANY DROPDOWN ========= */}

      <div className={styles.filterContainer}>
        <select
          className={styles.companyDropdown}
          value={selectedCompanyCode}
          onChange={(e) => setSelectedCompanyCode(e.target.value)}
        >
          {/* Logged-in user company always on top */}
          <option value={userData.admincode}>
            {userData.companyname} ({userData.adminemail})
          </option>

          {/* Super admin can see all companies */}
          {adminType === "1" &&
            companies
              .filter((c) => c.admincode !== userData.admincode)
              .map((c) => (
                <option key={c.id} value={c.admincode}>
                  {c.companyname} ({c.email})
                </option>
              ))}
        </select>
      </div>

      {/* ========= TABLE ========= */}

      <table className={styles.assessmentTable}>
        <thead>
          <tr>
            <th>Driver</th>
            <th>Email</th>
            <th>Company</th>
            <th>Department</th>
            <th>Score</th>
            <th>Validity</th>
            <th>Last Updated</th>
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan="7" className={styles.loadingRow}>
                Loading assessments...
              </td>
            </tr>
          ) : paginated.length === 0 ? (
            <tr>
              <td colSpan="7" className={styles.loadingRow}>
                No assessments found
              </td>
            </tr>
          ) : (
            paginated.map((a, i) => (
              <tr key={i}>
                <td>{a.driver_name}</td>
                <td>{a.driver_email}</td>
                <td>{a.companyname}</td>
                <td>{a.departmentName}</td>
                <td>
                  <img
                    className={styles.scoreImage}
                    src={`https://starbehaviors.com/uploadimage/${a.score || 1}.png`}
                    alt="Score"
                  />
                </td>
                <td>{new Date(a.validity).toLocaleDateString()}</td>
                <td>{new Date(a.score_timestamp).toLocaleDateString()}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* ========= PAGINATION ========= */}

      {totalPages > 1 && (
        <div className={styles.pagination}>
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
          >
            Prev
          </button>

          <span>
            Page {currentPage} of {totalPages}
          </span>

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => p + 1)}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default CompanyAssessmentDashboard;
